import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Isvg from 'react-inlinesvg';
import { FormattedMessage } from 'react-intl';
import { URL_APP_IOS, URL_APP_ANDROID } from 'constants/urls';
import css from './AppDownloadIcons.scss';

const ICON_APP_IOS = require('style-guide/templates/static/assets/images/css/download-appstore.svg');
const ICON_APP_ANDROID = require('style-guide/templates/static/assets/images/css/download-playstore.svg');

export const ANDROID = 'android';
export const IOS = 'ios';

export class AppDownloadIcons extends PureComponent {
  render() {
    const { extraClass, onClick: handleClick } = this.props;

    return (
      <ul className={cx(css.appDownloadIcons, extraClass)}>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={URL_APP_IOS}
            onClick={handleClick && handleClick.bind(null, IOS)}>
            <Isvg className="svg" uniquifyIDs={false} src={ICON_APP_IOS}>
              <FormattedMessage id="app-download-icons.download-link" defaultMessage="Download ClassPass for iPhone" />
            </Isvg>
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={URL_APP_ANDROID}
            onClick={handleClick && handleClick.bind(null, ANDROID)}>
            <Isvg className="svg" uniquifyIDs={false} src={ICON_APP_ANDROID}>
              <FormattedMessage
                id="app-download-icons.download-link-android"
                defaultMessage="Download ClassPass for Android"
              />
            </Isvg>
          </a>
        </li>
      </ul>
    );
  }
}

AppDownloadIcons.propTypes = {
  extraClass: PropTypes.string,
  onClick: PropTypes.func,
};
